<script setup lang="ts">
import { useNetwork } from '@vueuse/core';
import { apiAxiosInstance } from '@/api';

const contextStore = useContextStore();
const clientStore = useClientStore();
const miscStore = useMiscStore();

const { isOnline } = useNetwork();
const prod = import.meta.env.PROD;

const getOnLoadQueryParams = () => {
    const params = new URL(document.location.href).searchParams;
    return {
        loginToken: params.get('login_token'),
        passwordResetToken: params.get('password_reset_token'),
        referralId: Number.parseInt(params.get('referral_id') ?? 'x'),
    };
};

const initialize = async () => {
    if ((isOnline.value || !prod) && contextStore.isInitialized === false) {
        await miscStore.runLoader(async () => {
            await contextStore.init();
            const params = getOnLoadQueryParams();
            if (params.loginToken != null) {
                clientStore.auth.jwt = params.loginToken;
            }
            if (params.passwordResetToken != null) {
                clientStore.auth.passwordResetToken = params.passwordResetToken;
            }
            if (!Number.isNaN(params.referralId)) {
                try {
                    const { data } = await apiAxiosInstance.get(`/signup-referrals/${params.referralId}/lookup`);
                    if (data.enabled) {
                        clientStore.auth.referral = {
                            id: data.id,
                            name: data.branch_name,
                        };
                    }
                } catch {
                    // Referral not found or invalid — ignore
                }
            }
            await clientStore.validateSessionToken();
        })();
    }
};
await initialize();
watch(isOnline, initialize);
</script>

<template>
    <TopProgress />
    <div v-if="isOnline === false && prod">You are offline.</div>
    <div v-else-if="clientStore.auth.onloadSessionValidated && !clientStore.isValidatingSession">
        <RouterView />
        <DialogContainer />
    </div>
    <FullscreenLoader v-show="miscStore.isLoading" />
    <CookieConsent />
</template>
